export default "__VITE_ASSET__DrapplAK__"